// extracted by mini-css-extract-plugin
module.exports = {"Content":"Header_Content__10vg2"};